import React from 'react';
import PropTypes from 'prop-types';
import { ButtonWithIcon } from '@els/els-react--button';
import { RESPONSE_STATUS } from '@Pages/Login/ResetPasswordWithTokenDialog/ResetPasswordWithTokenDialogConstants';

function ResetPasswordWithTokenDialogFooter({ submit, close, responseStatus }) {
  const isLoading = responseStatus === RESPONSE_STATUS.LOADING;
  const isResult = responseStatus === RESPONSE_STATUS.SUCCESS;

  return (
    <div className="els-btn-group-right forgot-password-dialog__footer">
      {isResult ? (
        <ButtonWithIcon type="primary" sprite="ChevronRight" iconRight className="e2e-reset-password-with-token-success" onClick={close}>
          OK, got it
        </ButtonWithIcon>
      ) : (
        <>
          <ButtonWithIcon
            type="tertiary"
            sprite="Close"
            iconRight
            className="e2e-reset-password-with-token-cancel"
            disabled={isLoading}
            onClick={close}>
            Cancel
          </ButtonWithIcon>
          <ButtonWithIcon
            type="primary"
            sprite="ChevronRight"
            iconRight
            className="e2e-reset-password-with-token-continue"
            disabled={isLoading}
            onClick={submit}>
            Save
          </ButtonWithIcon>
        </>
      )}
    </div>
  );
}

ResetPasswordWithTokenDialogFooter.propTypes = {
  submit: PropTypes.func.isRequired,
  close: PropTypes.func.isRequired,
  responseStatus: PropTypes.string,
};

export default ResetPasswordWithTokenDialogFooter;
